<template>
  <div>
    <div style="padding-bottom:38px;margin-top:0">
      <div :style="`color:#${artistNameColor};font-size:48px;padding:20px 0;line-height:60px`">
        {{ artist.formatted_name }}
        <div style="display:inline-block;border-radius:50%;overflow:hidden;width:60px;height:60px;position:relative;vertical-align:top" v-if="showArtist">
          <img :src="pfimage" style="width:60px;height:60px;position:absolute;top:0;left:0">
        </div>
      </div>
      <a :href="fullink" target="_blank"><img :src="$imagehost + '/' + artist.image_1" style="display:block" width="520" /></a>
      <div style="padding:20px 20px 0 20px;" v-if="followers">
        <div style="font-size:15px;font-weight:500;letter-spacing:2px;margin-bottom:4px">SOCIAL REACH</div>
        <a :href="iglink"><img :src="$assetUrl('instagram.png')" style="vertical-align:middle;margin-right:8px" /></a> 
        <span style="font-weight:500">{{ followers }}</span>
      </div>
      <div style="font-size:19px;margin-top:15px" v-html="formatText(artist.profile)">
      </div>
      <div style="margin-top:20px" v-if="artist.image_2">
        <a :href="fullink2" v-if="fullink2">
          <img :src="$imagehost + '/' + artist.image_2" style="display:block" width="520" />
        </a>
      </div>
      <div style="margin-top:20px">
        <template v-if="artist.portfolio_url">
          <a :style="`padding:5px 12px;color:#fff;text-decoration:none;background-color:#${linkColor};border-radius:6px`" 
            :href="fullink">view {{ firstName }}'s portfolio</a>
        </template>
      </div>
    </div>
    <div v-if="!last" style="margin:10px -35px;background-color:#f9f9f9;height:40px">
      &nbsp;
    </div>
  </div>
</template>

<script>
export default {
  props:{
    artist: Object,
    last: Boolean,
    animation: Boolean,
    hidefol: Boolean,
    colors: Object,
    showArtist: Boolean
  },
  data() {
    return {
      cclink: this.$store.state.cclink + 'SHOWCASE',
      artistDetail: {},
      followers: '',
      iglink: ''
    }
  },
  computed: {
    pfimage () {
      return this.$imagehost + '/images/artist/' + this.artist.portfolio_url + '/profile/crop/320/' + this.artist.portfolio_url + '.jpg'
    },
    firstName () {
      if(this.artist) {
        if(this.animation) {
          return this.artist.formatted_name
        }
        return this.artist.formatted_name.split(' ').slice(0, 1)[0]
      }
      return ''
    },
    ntlink () {
      let ntlink = this.cclink
      if(this.artist) {
        if(this.artist.formatted_name) {
          ntlink = this.cclink + '&utm_content=' + encodeURIComponent(this.artist.formatted_name)
        }
      }
      return ntlink
    },
    fullink () {
      if(this.artist.image_1_link){
        return this.artist.image_1_link + this.ntlink
      }
      return this.pflink
    },
    pflink() {
      if(this.animation) {
        return this.$host + '/animators/' + this.artist.portfolio_url + this.ntlink
      }
      return this.$host + '/artists/' + this.artist.portfolio_url + this.ntlink
    },
    fullink2 () {
      if(!this.artist.image_2_link) {
        return this.pflink
      }
      
      return this.artist.image_2_link + this.ntlink
    
    },
    artistNameColor() {
      return this.colors.artistNameColor || 'ce0e2d'
    },
    linkColor() {
      return this.colors.linkColor || 'ce0e2d'
    }
  },
  created () {
    this.fetchArtist(this.artist.portfolio_url)
  },
  methods: {
    formatText(text) {
      if(!text) {
        return ''
      }
      return text.replace(/\r/g, '<br/>')
    },
    async fetchArtist () {
      let url = 'collections/artists/details'
     
      let res = await this.$apix.post(url, { artist_id: Number(this.artist.artist_id), lang: 'UK', animator: this.animation })
      this.artistDetail = res.data
      if(this.artistDetail.instagram) {
        
        if((!this.hidefol) && this.artistDetail.followers > 10000) {
          this.followers = this.kFormatter(this.artistDetail.followers)
          this.iglink = 'https://www.instagram.com/' + this.artistDetail.instagram
          
        }
      }
    },
    kFormatter(num) {
      return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    }
  },
  watch: {
    artist: function () {
      if(this.artist) {
        this.fetchArtist()
      }
      
    }
  }
}
</script>

<style>

</style>